import * as cx from 'classnames';
import { SERVER_FULL_NAME, SERVER_SLOGAN } from 'mk/autogenerated/translations/Header.072c0ff9b83d49c26107d384ca3c6c23'
import assetUrl from 'mk/common/assetUrl';
import { ACTIVE_SERVER_ID } from 'mk/settings';
import * as homeUrls from 'mk2/apps/home/urls';
import Img from 'mk2/components/Img';
import * as React from 'react';
import styles from './Header.mscss';

interface OwnProps {
    /** Centered text */
    heading?: React.ReactNode;

    /** Left content - e.g. back button or hamburger menu */
    left?: React.ReactNode;

    /** Right content - e.g. primary action button */
    right?: React.ReactNode;

    /** Boolean value if we are on the mobile */
    isMobile?: boolean;

    /** Boolean value if ??? */
    hasBackBtn?: boolean;

    /** Should we display a notification circle on the hamburger/ */
    notifications?: number;

    /** Should we display a logo instead of heading text? */
    showLogo?: boolean;
}

class Header extends React.Component<OwnProps> {

    public render() {
        const { heading, left, right, isMobile, hasBackBtn, notifications, showLogo } = this.props;

        return (
            <div className={styles.Header}>
                <div className={styles.Header__center}>
                    {(heading) ? heading : (showLogo) ? (
                            <a className={styles.Header__logo} title={SERVER_FULL_NAME + ' - ' + SERVER_SLOGAN} href={homeUrls.homepage}>
                                {ACTIVE_SERVER_ID === 207 ? (
                                    <Img width={126} height={20} alt={SERVER_FULL_NAME + ' - ' + SERVER_SLOGAN} src={assetUrl + 'img/logos/strollerbase.png'} lazy={false} />
                                ) : (
                                    <Img width={29} height={23} alt={SERVER_FULL_NAME + ' - ' + SERVER_SLOGAN} src={assetUrl + 'img/logos/ver-4/horse@2x.png'} lazy={false} />
                                )}
                            </a>
                        ) : null}
                </div>
                {(isMobile && !hasBackBtn && (ACTIVE_SERVER_ID !== 207)) ? (
                    <div className={styles.Header__hamburger}>
                        <label htmlFor="mobileMenuTrigger" className={styles['Header__hamburger--icon']}>
                            <i className={cx('fa', 'fa-bars')}/>
                            {(notifications && notifications > 0) ? (
                                <span className={styles['Header__hamburger--notification']} />
                            ) : null}
                        </label>
                    </div>
                ) : null}
                <div className={styles.Header__left}>
                    {left}
                </div>
                <div className={styles.Header__right}>
                    {right}
                </div>
            </div>
        );
    }
}

export default Header;
